import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { TID } from "@/constants/testIds";
import { toast } from "sonner";

const TABS = [
  { id: "candidates", label: "Candidate Pipeline" },
  { id: "employers", label: "Employer Pipeline" },
  { id: "applications", label: "Application Pipeline" },
];

export default function AgencyPipeline() {
  const [tab, setTab] = useState("candidates");
  const [data, setData] = useState(null);

  const load = async () => {
    const { data } = await api.get(`/admin/pipeline/${tab}`);
    setData(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [tab]);

  const moveCandidate = async (id, stage) => {
    await api.post(`/candidates/${id}/stage`, null, { params: { stage } });
    toast.success(`Moved to ${stage}`);
    load();
  };

  const moveEmployer = async (id, stage) => {
    await api.post(`/employers/${id}/stage`, null, { params: { stage } });
    toast.success(`Moved to ${stage}`);
    load();
  };

  const stages = data?.stages || [];

  return (
    <div data-testid={TID.agencyPipelineBoard}>
      <div className="mb-6">
        <div className="eyebrow mb-2">Recruiting Pipeline</div>
        <h1 className="font-display text-3xl font-bold text-navy">Visual Pipeline</h1>
        <p className="text-sm text-slate-500 mt-1">Move records through your recruiting workflow.</p>
      </div>

      <div className="flex gap-2 mb-6">
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${tab === t.id ? "bg-navy text-white" : "bg-white text-slate-600 border border-slate-200 hover:border-navy"}`}>
            {t.label}
          </button>
        ))}
      </div>

      <div className="overflow-x-auto no-scrollbar pb-6">
        <div className="flex gap-4 min-w-max">
          {stages.map(col => (
            <div key={col._id} className="kanban-col p-3 w-72 flex-shrink-0">
              <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-3 flex items-center justify-between">
                <span>{col._id}</span>
                <span className="text-navy">{(col.candidates || col.employers || col.apps || []).length}</span>
              </div>
              <div className="space-y-2">
                {(col.candidates || []).map(c => (
                  <div key={c.id} className="bg-white border border-slate-200 rounded-lg p-3 shadow-sm">
                    <div className="font-semibold text-navy text-sm">{c.name}</div>
                    <div className="text-xs text-slate-500">{c.headline}</div>
                    <div className="text-xs text-slate-500 mt-1">{c.city}{c.state ? `, ${c.state}` : ""}</div>
                    <select defaultValue={col._id} onChange={e => moveCandidate(c.id, e.target.value)}
                      className="mt-2 w-full border rounded text-xs px-2 py-1">
                      {stages.map(s => <option key={s._id}>{s._id}</option>)}
                    </select>
                  </div>
                ))}
                {(col.employers || []).map(e => (
                  <div key={e.id} className="bg-white border border-slate-200 rounded-lg p-3 shadow-sm">
                    <div className="font-semibold text-navy text-sm">{e.company_name}</div>
                    <div className="text-xs text-slate-500">{e.industry}</div>
                    <div className="text-xs text-slate-500">{e.city}</div>
                    <select defaultValue={col._id} onChange={ev => moveEmployer(e.id, ev.target.value)}
                      className="mt-2 w-full border rounded text-xs px-2 py-1">
                      {stages.map(s => <option key={s._id}>{s._id}</option>)}
                    </select>
                  </div>
                ))}
                {(col.apps || []).map(a => (
                  <div key={a.id} className="bg-white border border-slate-200 rounded-lg p-3 shadow-sm">
                    <div className="font-semibold text-navy text-sm">{a.candidate_name}</div>
                    <div className="text-xs text-slate-500">{a.job_title}</div>
                    <div className="text-xs text-slate-500">→ {a.employer_name}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
